<template>
  <div class="manage-edit-main-con">
    <!-- 内容编辑模块 -->
    <section
      v-for="(pItem, pIndex) in formArr"
      :key="pIndex"
      :class="pIndex ? 'mg-top30' : ''"
      class="detail-baseInfo pd-btm15">
      <h3 class="bor-btm-gray model-title f-df f-jcsb f-ai">
        <span class="f-fs16 model-title-text mg-right15 pd-btm10 pd-right15">{{ pItem.title }}</span>
        <span
          v-show="!pItem.isEdit && pageType !== 'check'"
          :class="pItem.isAllowEdit ? 'color-blue' : 'color-gray-ccc'"
          class="pd-row10 pd-btm10 f-csp"
          @click="formItemEdit(pItem, pIndex)">
          <i class="el-icon-edit"></i>
          <em class="f-fwn">修改</em>
        </span>
      </h3>
      <!--基础信息：列表形式-->
      <dl class="mg-top15 f-df f-fww pd-row30">
        <dd
          v-for="(item, index) in pItem.infosList"
          :key="index"
          :style="{width: (item.width || pItem.initWidth || initWidth) + '%'}"
          :class="{
            'f-ai': pItem.isEdit,
            'f-fww': pItem.isWrap
          }"
          class="mg-top15 f-df f-pr">
          <span v-if="item.isRequired" :class="pItem.isEdit ? 'edit-required-icon' : ''" class="color-red-mark f-pa require-item">*</span>
          <label v-show="item.label" :style="{'min-width': (pItem.labelWidth || '56') + 'px'}" class="form-label txt-align-last" v-html="item.label"></label>
          <span v-show="item.label">：</span>
          <div
            v-if="!pItem.isEdit || pageType === 'check'"
            :class="pItem.isWrap || item.isWrap ? 'wid100' : 'flex-1 item-info-span'"
            class="color-lighter-gray f-lhn">
            <!-- 直接显示value -->
            <span v-if="!item.isShowMore">
              {{ handleTxtByKey(item, item.value) || '-' }}{{ item.isParamAddUnit ? item.unit || '' : ''}}
            </span>
            <!-- 判断当前值是否超出限制显示最大长度 -->
            <span
              v-else-if="handleTxtByKey(item, item.value).length < (item.showTxtLeng || showTxtLeng)"
              v-html="handleTxtByKey(item, item.value) || '-'">
            </span>
            <!-- 文字展开更多 、 收起情况 -->
            <span v-else>
              <span v-if="!item.txtMore" v-html="handleTxtByKey(item, item.value).substr(0, item.showTxtLeng || showTxtLeng) + '...'"></span>
              <span v-else v-html="handleTxtByKey(item, item.value)"></span>
              <em class="f-fwn color-blue f-csp" @click="item.txtMore = !item.txtMore">{{ !item.txtMore ? '更多' : '收起' }}</em>
            </span>
          </div>
          <div
            v-else
            :class="classObject(pItem, item)">
            <el-select
              v-if="item.type === 'select'"
              v-model="item.inpVal"
              :disabled="!!(item.noInsert && pageType === 'edit')"
              :multiple="item.isMoreChoose"
              clearable
              :placeholder="item.placeholder || '请选择'"
              @change="componentChange($event, item, pIndex)">
              <el-option
                v-for="elem in item.children"
                :key="elem.id"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
            <!-- 树形 -->
            <el-cascader
              v-else-if="item.type === 'tree'"
              v-model="item.inpVal"
              :disabled="!!(item.noInsert && pageType === 'edit')"
              :options="item.children"
              :props="item.props || props"
              :filterable="!!item.filterable"
              :separator="item.separator || ' - '"
              :placeholder="item.placeholder || '请选择'"
              :clearable="!!item.clearable" />
            <el-date-picker
              v-else-if="item.type === 'date'"
              v-model="item.inpVal"
              :type="item.dateType || 'date'"
              :format="item.valueFormat || 'yyyy-MM-dd'"
              :value-format="item.valueFormat || 'yyyy-MM-dd'"
              :disabled="!!(item.noInsert && pageType === 'edit')"
              :placeholder="item.placeholder || '请选择'"
              @change="componentChange($event, item, pIndex)" />
            <textarea
              v-else-if="item.type === 'textarea'"
              v-model="item.inpVal"
              :style="{height: (item.textHei || '200') + 'px'}"
              class="textarea-con f-fs2 f-lh22 f-cl6">
            </textarea>
            <el-input
              v-else
              v-model="item.inpVal"
              :maxlength="item.maxlength"
              :show-word-limit="!!item.maxlength"
              :disabled="!!((item.noInsert && item.isRequired && item.value) || (item.noInsert && !item.isRequired))"
              :placeholder="item.placeholder || '请输入'"
              :class="item.isReg ? '' : 'color-red-mark'"
              class="flex-1 f-cl6 edit-inp"
              clearable
              @change="componentChange($event, item, pIndex)">
              <template v-if="item.unit" slot="append">{{ item.unit }}</template>
            </el-input>
          </div>
        </dd>
      </dl>
      <!-- 编辑保存 、取消按钮 -->
      <div v-if="pItem.isEdit" class="f-df f-ai mg-top30 pd-row30">
        <el-button
          size="mini"
          type="primary"
          v-loading.fullscreen.lock="pItem.isSaveLoading"
          element-loading-text="正在保存..."
          @click="saveBtn(pItem, pIndex)">
          保存
        </el-button>
        <el-button size="mini" class="mg-left15" @click="cancelBtn(pItem, pIndex)">取消</el-button>
      </div>
    </section>
    <div v-show="0" id="excelHtml" v-html="tableHtml"></div>
  </div>
</template>

<script>
export default {
  props: {
    pageType: { // 是否允许页面被编辑
      type: String,
      default: 'check' // 默认是check --- 查看，add --- 新增， edit --- 编辑
    },
    formArr: {
      type: Array,
      default: function() {
        return []
      }
    },
    formRules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isAllowEdit: { // 是否允许页面被编辑
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showTxtLeng: 500,
      initWidth: '50',
      tableHtml: '',
      copyText: '',
      clipboard: null,
      props: {
        value: 'id',
        label: 'name',
        checkStrictly: true,
        expandTrigger: 'hover',
        lazy: true,
        lazyLoad: (node, resolve) => {
          this.loadNode(node, resolve)
        }
      }
    }
  },
  methods: {
    // 树形
    loadNode(node, resolve) {
      if (node.data.leaf || node.data.children) {
        resolve([])
        return
      }
      this.$emit('treeLoadNode', node, data => {
        resolve(data)
      })
    },
    classObject(pItem, item) {
      const obj = {
        'flex-1 edit-box': !pItem.isWrap && !item.isWrap,
        'wid100 mg-top5': pItem.isWrap || item.isWrap
      }
      const key = (item.type || 'input') + '-box'
      obj[key] = true
      return obj
    },
    // 页面初始化
    init() {
      this.tableHtml = ''
      this.copyText = ''
      if (this.clipboard) this.clipboard.destroy()
      this.clipboard = null
    },
    // 通过key获取value, flag --- true: 则表示其他地方传值识别
    handleTxtByKey(item, value, flag) {
      if (item.type === 'select' && item.children) {
        if (typeof value === 'object') {
          value = value.reduce((str, itemVal) => {
            const findObj = item.children.find(elem => elem.id + '' === itemVal + '') || {}
            if (findObj.name) str += findObj.name + ','
            return str
          }, '')
          if (value) value = value.substr(0, value.length - 1)
        } else {
          const findObj = item.children.find(elem => elem.id + '' === value + '') || {}
          value = findObj.name || ''
        }
        // !value && (item.inpVal = '')
      } else if (item.type === 'tree' && value) {
        if (typeof value === 'object') {
          value = value.join(item.separator || ' - ')
        }
      }
      return value || ''
    },
    // 模块编辑
    formItemEdit(pItem, index) {
      this.$emit('formItemEdit', pItem, index)
    },
    // 组件值修改
    componentChange($event, item, pIndex) {
      // console.log($event)
      this.$emit('componentChange', $event, item, 'insert', pIndex)
    },
    // 取消
    cancelBtn(item, index) {
      this.$emit('cancelBtn', item, index)
    },
    // 保存按钮
    saveBtn(item, index) {
      // formRules
      const requiredItem = item.infosList.find(elem => elem.isRequired && !elem.inpVal)
      if (requiredItem) {
        this.$message({
          type: 'warning',
          message: requiredItem.placeholder || ('请先选择' + requiredItem.label + '！')
        })
        return
      }
      let regTxt = ''
      item.infosList.forEach(elem => {
        if (regTxt) return
        // 字段是否存在正则验证以及是否符合规则
        if (elem.inpVal && elem.regs) {
          elem.regs.forEach(regItem => {
            let reg = regItem.reg
            if (typeof regItem.reg === 'string') {
              reg = this.$util.evil(regItem.reg)
            }
            // const reg = eval(elem.reg)
            const isReg = reg.test(elem.inpVal)
            if (!isReg) regTxt = elem.label + '：' + (regItem.message || '格式不正确')
          })
          if (!regTxt) elem.isReg = true
        } else {
          elem.isReg = true
        }
      })
      // 判断验证提示
      if (regTxt) {
        this.$message({
          type: 'warning',
          message: regTxt
        })
        return
      }
      this.$emit('saveBtn', item, index)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wid100{width: 100%;}
.manage-edit-main-con{
  .model-title-text{
    border-bottom: 3px solid @color-blue;
  }
  padding: 15px 20px 20px;
  & .require-item{
    top: 0;
    left: -8px;
    &.edit-required-icon{
      top: 8px;
    }
  }
  & .item-info-span,
  & .edit-box,
  {
    margin-right: 100px;
  }
}
/deep/.edit-box{
  & .el-select,
  & .el-cascader{
    width: 100%;
  }
}
</style>
